import React, { useEffect, useState } from "react";
import { useLocation,useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
// import "./import.css"; // Use the same CSS as the export page
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import icdLogo from "./container-corporation-of-india-logo-concor.svg";
import bgImage from "./bg1.jpg"; 

import { useMemo } from "react";
const Import = () => {
  
const token = localStorage.getItem("authToken");
const user = localStorage.getItem("user");
const parsedUser = user ? JSON.parse(user) : null;
// put with your other useState calls:
const [searchForm, setSearchForm] = useState({ transactionType: "", crnNumber: "" });
const [isLoading, setIsLoading] = useState(false);

// put with your other handlers:
const handleSearchChange = (e) => {
  const { name, value } = e.target;
  setSearchForm(prev => ({ ...prev, [name]: value }));
};

const handleSearchSubmit = async (e) => {
  e.preventDefault();
  const { transactionType, crnNumber } = searchForm;
  if (!transactionType || !crnNumber) return;

  setIsLoading(true);
  try {
    const endpoint =
      transactionType === "Export"
        ? `https://kycl.in/api/api/export?crnNumber=${crnNumber}`
        : `https://kycl.in/api/api/import?crnNumber=${crnNumber}`;

    const response = await axios.get(endpoint);
    if (!response?.data) return;

    localStorage.setItem("searchResults", JSON.stringify(response.data));
    const dataArray = transactionType === "Export" ? response.data.gate_data : response.data.rake_in_data;
    const hasIn = Array.isArray(dataArray) && dataArray.some(item => item.type === "IN");

    if (hasIn) {
      navigate(transactionType === "Export" ? "/Export" : "/Import", {
        state: { formData: searchForm, responseData: response.data }, // keeps same shape for target page
      });
    } else {
      console.warn("No 'IN' entries found.");
    }
  } catch (err) {
    console.error("Error fetching data:", err);
  } finally {
    setIsLoading(false);
  }
};

    const navigate = useNavigate();
  const location = useLocation();
  const { formData, responseData } = location.state || { formData: {}, responseData: {} };
  const [isLoaded, setIsLoaded] = useState(false);

    const [showModal, setShowModal] = useState(false);
   const [popupImages, setPopupImages] = useState([]);
  
  const handleOpenModal = (images) => {
    setPopupImages(images.filter(img => img.url)); // only keep images that exist
    setShowModal(true);
  };
  
    const handleCloseModal = () => {
      setShowModal(false);
      setPopupImages("");
    };

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 300);
  }, []);

  // Status badge component
  const StatusBadge = ({ status }) => (
    <span className={`badge ${status === 'Y' ? 'bg-danger' : 'bg-success'}`}>
      {status === 'Y' ? 'Yes' : 'No'}
    </span>
  );

const TimelineItem = ({ title, date, time, wagon, last, onClick, gate_no, to, JOB_ORDER_ID }) => (
  <div
    className={`timeline-item ${last ? "last-record" : "mb-3"}`}
    style={{ cursor: "pointer" }}
    onClick={onClick}
  >
    <div className={`timeline-badge ${last ? "bg-success" : "bg-secondary"}`}></div>
    
    <div
      className={`timeline-content p-3 rounded shadow-sm ${
        last ? "bg-warning text-dark border border-danger" : "bg-light"
      }`}
    >
      <h6 className={`mb-1 ${last ? "text-danger fw-bold" : "text-primary"}`}>
        {title}
      </h6>

      {wagon && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            Wagon No: <strong>{wagon}</strong>
          </small>
        </div>
      )}

      {gate_no && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            Gate No: <strong>{gate_no}</strong>
          </small>
        </div>
      )}

      {to && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            Dest: <strong>{to}</strong>
          </small>
        </div>
      )}

      {JOB_ORDER_ID && (
        <div className="text-dark mb-1">
          <small style={{ fontWeight: "bold" }}>
            JOB ORDER ID: <strong>{JOB_ORDER_ID}</strong>
          </small>
        </div>
      )}

      <div className="d-flex justify-content-between">
        {date && <span className="text-muted">{date}</span>}
        {time && <span className="fw-bold">{time}</span>}
      </div>
    </div>
  </div>
);





  // Format date and time separately
  const formatDateTime = (dateString) => {
    if (!dateString) return { date: "N/A", time: "N/A" };
    
    const dateObj = new Date(dateString);
    return {
      date: dateObj.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      }),
      time: dateObj.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      })
    };
  };

    const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailData, setDetailData] = useState(null);
  // ---------- build timeline events (only the important yard items now) ----------
  const events = [];

  // Rake Inward (only if arrival_time exists)
  const rIn = responseData.rake_in_data?.[0];
  if (rIn?.arrival_time) {
    events.push({ key: 'rake-in', title: 'Rake Inward', datetime: rIn.arrival_time, wagon: rIn.wagon_no || '', record: rIn });
  }


  const cgil = responseData.cgiData?.[0];
  // prepare yard array with parsed timestamps
  const yardArr = (responseData.yard_data || [])
    .filter(rec => rec && rec.yard_created_at)
    .map(rec => ({ ...rec, _ts: new Date(rec.yard_created_at) }))
    .filter(r => !isNaN(r._ts.getTime())); // keep valid dates only

 if (yardArr.length > 0 && cgil?.end_time) {
  const cgiEnd = new Date(cgil.end_time);
  if (!isNaN(cgiEnd.getTime())) {
    const afterCgi = yardArr.filter(r => r._ts > cgiEnd);
    if (afterCgi.length > 0) {
      const closestAfter = afterCgi.reduce((a, b) => (a._ts < b._ts ? a : b));
      const isDuplicate = events.some(
        e => e.record && e.record.yard_created_at === closestAfter.yard_created_at
      );
      if (!isDuplicate) {
        events.push({
          key: 'yard-landed',
          title: 'Arrival In Yard ',
          datetime: closestAfter.yard_created_at,
          to: closestAfter.to,
          record: closestAfter
        });
      }
    }
  }
}

  // 2) Placed in Import Warehouse -> the yard record immediately before destuff start
  const destuff = responseData.deStuffingData;
  if (destuff?.start_time && yardArr.length > 0) {
    const destuffStart = new Date(destuff.start_time);
    if (!isNaN(destuffStart.getTime())) {
      const beforeDestuff = yardArr.filter(r => r._ts < destuffStart);
      if (beforeDestuff.length > 0) {
        // pick the one closest to destuffStart (max timestamp less than start_time)
        const closest = beforeDestuff.reduce((a, b) => (a._ts > b._ts ? a : b));
        // avoid duplicate if it's same as earliest
        const isDuplicate = events.some(e => e.record && e.record.yard_created_at === closest.yard_created_at);
        if (!isDuplicate) {
          events.push({
            key: 'yard-placed-import',
            title: 'Placed in Import Warehouse',
            datetime: closest.yard_created_at,
            to: closest.to,
            record: closest
          });
        }
      }
    }
  }

  // De-Stuffing Start & End
  if (destuff?.start_time) {
    events.push({ key: 'destuff-start', title: 'De-Stuffing Start', datetime: destuff.start_time, record: destuff });
  }
  if (destuff?.end_time) {
    events.push({ key: 'destuff-end', title: 'De-Stuffing End', datetime: destuff.end_time, record: destuff });
  }


  // Delivery Start & End
  const del = responseData.delivery_data?.[0];
  if (del?.start_time) {
    events.push({ key: 'delivery-start', title: 'Delivery Start', datetime: del.start_time, record: del });
  }
  if (del?.end_time) {
    events.push({ key: 'delivery-end', title: 'Delivery End', datetime: del.end_time, record: del });
  }

  // Gate Out (only one if gate_out_time exists)
  const gout = responseData.gate_data?.[0];
  if (gout?.gate_out_time) {
    events.push({ key: 'gate-out', title: 'Gate Out', gate_no: gout.gate_no, datetime: gout.gate_out_time, record: gout });
  }

  // Rake Out (only if updated_at exists)
  const rout = responseData.rake_data?.[0];
  if (rout?.updated_at) {
    events.push({ key: 'rake-out', title: 'Rake Out', datetime: rout.updated_at, wagon: rout.wagon_no || '', record: rout });
  }

  // CGI
  // const cgil = responseData.cgiData?.[0];
  if (cgil?.end_time) {
    events.push({ key: 'cgi', title: 'CGI', datetime: cgil.end_time, record: cgil });
  }

  //EJO
  const ejo = responseData.ejoData?.[0];
  if(ejo?.CREATED_AT){
    events.push({key:"ejo", title: 'EJO', datetime: ejo.CREATED_AT, record: ejo, JOB_ORDER_ID: ejo.JOB_ORDER_ID || '',})
  }

  // Sort events chronologically
  events.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

  // Handle click to open detail modal
  function openDetailModal(event) {
    setDetailData(event);
    setShowDetailModal(true);
  }
const yardRecordsToShow = useMemo(() => {
  const keys = ["yard-landed", "yard-placed-import"];
  return keys
    .map(k => events.find(e => e.key === k)?.record)
    .filter(Boolean);
}, [events]);

  return (
    <div
      className="position-relative"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
    <div >
      {/* Header */}
      
<header className="dashboard-header py-4">
  <div className="container-fluid">
    <div className="d-flex align-items-center justify-content-between">

      {/* LEFT: Logo */}
      <div className="logo-area d-flex align-items-center me-3" style={{ minWidth: 100 }}>
        <img
          src={icdLogo}
          alt="ICD TKD"
          style={{ maxHeight: 110, objectFit: "contain", display: "block" }}
        />
      </div>

      {/* CENTER: Title + subtitle + badge */}
      <div className="title-area flex-grow-1 d-flex flex-column align-items-center px-3">
        <h1 className="display-5 fw-bold mb-1 text-secondary text-center text-secondry">
          Customer <span className="text-primary">Dashboard</span>
        </h1>

        <p className="subtitle lead mb-2 text-center">
          AI-Powered Real-Time Status & Tracking Dashboard
        </p>

        <div className="badge-area d-inline-block p-1 px-2 border rounded bg-light shadow-sm">
          <small className="fw-bold text-primary">For ICD Tughlakabad</small>
        </div>
      </div>

      {/* RIGHT: Search (select above, input+button) */}
      <div className="search-area ms-3" style={{ minWidth: 260 }}>
        <form onSubmit={handleSearchSubmit} id="formAuthentication" className="mb-0">
          <div className="mb-2">
            <select
              name="transactionType"
              className="form-select"
              value={searchForm.transactionType}
              onChange={handleSearchChange}
              required
            >
              <option value="" hidden>Select Transaction Type</option>
              <option value="Export">Export</option>
              <option value="Import">Import</option>
            </select>
          </div>

          <div className="input-group">
            <input
              type="text"
              name="crnNumber"
              className="form-control"
              placeholder="CRN/Container Number"
              value={searchForm.crnNumber}
              onChange={(e) =>
                setSearchForm((prev) => ({ ...prev, crnNumber: e.target.value.toUpperCase() }))
              }
              required
            />
            <button
              type="submit"
              className="btn btn-search"
              disabled={isLoading}
               style={{ backgroundColor: "#C75000", borderColor: "#C75000", color: "#fff" }}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                  Searching...
                </>
              ) : (
                "Search"
              )}
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</header>



      {/* Main Content */}
      <div className="container mb-5">
        <div className="row g-4">
          {/* Timeline Column */}
          <div className="col-lg-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-header bg-white border-0 py-3">
                <h5 className="mb-0 text-primary">Container Movement</h5>
              </div>
              <div className="card-body">
              <div className="timeline">
              {events.map((e, i) => {
                const { date, time } = formatDateTime(e.datetime);
                return (
                  <TimelineItem
                    key={e.key}
                    title={e.title}
                    date={date}
                    time={time}
                    wagon={e.wagon}
                    JOB_ORDER_ID={e.JOB_ORDER_ID}
                    gate_no={e.gate_no}
                    to={e.to}
                    last={i === events.length - 1}
                    onClick={() => openDetailModal(e)}
                  />
                );
              })}
            </div>
              </div>
            </div>
          </div>

          {/* Status Cards Column */}
          <div className="col-lg-8">
            <div className="row g-4">
              {/* Damage Status */}
              <div className="col-md-6">
            <div className="card border-0 shadow-sm h-100">
  <div className="card-header bg-white border-0 py-3">
    <div className="d-flex justify-content-between ">
      <div>
        <h5 className="mb-0 text-primary mb-2">Container</h5>
        <span className="fw-bold">
          {responseData?.rake_in_data?.[0]?.container_no || "N/A"}
        </span>
      </div>
 <div>
          <h5 className=" text-primary mb-2">Final Status</h5>
          <span className="fw-bold">
         {responseData?.gate_data?.length > 0 && (
  <div>Departed</div>
)}
  <div className="small text-muted mt-1">
    {responseData?.gate_data?.[0]?.gate_out_time ? (
      <span className="fw-bold">
        {new Date(responseData.gate_data[0].gate_out_time).toLocaleString("en-US", {
          month: "short", // "May"
          day: "numeric", // "14"
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,   // 12-hour format with AM/PM
        })}
      </span>
    ) : (
      ""
    )}
  </div>

          </span>
        </div>
    
    </div>

    {/* <h5 className="mb-0 text-primary">Container Status</h5> */}
  </div>

  <div className="card-body">
    <div className="d-flex justify-content-between mb-1">
      {/* <div>
        <h6 className="text-muted mb-1 text-secondry">Damage Status</h6>
        <StatusBadge status={responseData?.gate_data?.[0]?.is_container_damage || "N"} />
      </div> */}
      <div>
  <h5 className="mb-0 text-primary">Last Yard Location</h5>
  <span className="fw-bold">
    {responseData?.icdCurData?.[0]?.to || ""}
  </span>
  <div className="small text-muted mt-1">
    {responseData?.icdCurData?.[0]?.yard_created_at ? (
      <span className="fw-bold">
        {new Date(responseData.icdCurData[0].yard_created_at).toLocaleString("en-US", {
          month: "short", // "May"
          day: "numeric", // "14"
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,   // 12-hour format with AM/PM
        })}
      </span>
    ) : (
      ""
    )}
  </div>
</div>
      <div>
        <h5 className="text-muted mb-1 text-primary">Hazardous</h5>
        <StatusBadge status={responseData?.gate_data?.[0]?.hazardous_container || "N"} />
      </div>

      {/* <div className="bg-light rounded shadow-sm">
        <h6 className="text-uppercase text-muted text-secondry">Container/CRN</h6>
        <p className="mb-0 fs-5 fw-bold">
          {responseData?.rake_in_data?.[0]?.container_no || "N/A"}
        </p>
      </div> */}
    </div>

    {/* {responseData.yard_data?.length > 0 && (
      <div className="mt-4">
        <h6 className="text-muted mb-2">Current Location</h6>
        <div className="bg-light p-3 rounded">
          <span className="fs-4 fw-bold">
            {responseData.yard_data[0].to || "N/A"}
          </span>
        </div>
      </div>
    )} */}
  </div>
</div>

                
              </div>

              {/* Shipping Info */}
              <div className="col-md-6">
                <div className="card border-0 shadow-sm h-100">
                  <div className="card-header bg-white border-0 py-3">
                    <h5 className="mb-0 text-primary">Shipping Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="mb-3">
                      <h6 className="text-muted mb-1 text-secondry">Shipping Line</h6>
                      <p className="mb-0 fw-bold">
                        {responseData?.deStuffingData?.shipping_liner_code || "N/A"}
                      </p>
                    </div>
                    
                    {/* <div className="mb-3">
                      <h6 className="text-muted mb-1">Container Size</h6>
                      <p className="mb-0 fw-bold">
                        {responseData?.gate_data?.[0]?.container_size || "N/A"}
                      </p>
                    </div> */}
                    
                    <div className="mb-3">
                      <h6 className="text-muted mb-1 text-secondry">Permit Number</h6>
                      <p className="mb-0 fw-bold">
                        {responseData?.gate_data?.[0]?.permit_no || "N/A"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Detailed Sections */}
              <div className="col-12">
                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-white border-0 py-3">
                    <h5 className="mb-0 text-primary">Transaction Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="accordion" id="transactionAccordion">
                      {/* Rake Inward Transactions */}
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="rakeInHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#rakeInCollapse" 
                            aria-expanded="true" 
                            aria-controls="rakeInCollapse"
                          >
                            Rake Inward Transactions
                          </button>
                        </h2>
                        <div 
                          id="rakeInCollapse" 
                          className="accordion-collapse collapse show" 
                          aria-labelledby="rakeInHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                          <div className="accordion-body p-0">
                            {responseData.rake_in_data?.length > 0 ? (
                              <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Train No</th>
                                      <th>Wagon No</th>
                                      <th>Seal 1</th>
                                      <th>Seal 2</th>
                                      <th>Arrival Time</th>
                                      <th>Equipment</th>
                                      <th> </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {responseData.rake_in_data.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.train_no || "N/A"}</td>
                                        <td>{item.wagon_no || "N/A"}</td>
                                        <td>{item.seal_1_no || "N/A"}</td>
                                        <td>{item.seal_2_no || "N/A"}</td>
                                        <td>
                                          <div className="d-flex flex-column">
                                            <span>{formatDateTime(item.arrival_time).date}</span>
                                            <small className="text-muted">{formatDateTime(item.arrival_time).time}</small>
                                          </div>
                                        </td>
                                        <td>{item.equipment_name || "N/A"}</td>
                               <td>
      <button
        className="btn btn-sm btn-primary"
        onClick={() =>
          handleOpenModal([
            { title: "Wagon", url: `https://ctas.live/ocr_backend/rake_ocr_1/`+item.wagon_no_image },
            { title: "Container 1", url: `https://ctas.live/ocr_backend/rake_ocr_1/`+item.container_no_image_1 },
            { title: "Container 2", url: `https://ctas.live/ocr_backend/rake_ocr_1/`+item.container_no_image_2 }
          ])
        }
      >
        Evidence
      </button>
    </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No rake inward data available</div>}
                          </div>
                        </div>
                      </div>

                      {/* CGI Transactions */}
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="cgiHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#cgiCollapse" 
                            aria-expanded="false" 
                            aria-controls="cgiCollapse"
                          >
                            CGI Transactions
                          </button>
                        </h2>
                        <div 
                          id="cgiCollapse" 
                          className="accordion-collapse collapse" 
                          aria-labelledby="cgiHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                          <div className="accordion-body p-0">
                            {responseData.cgiData?.length > 0 ? (
                              <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Seal No 1</th>
                                      <th>Seal No 2</th>
                                      <th>Damage Flag</th>
                                      <th>End Time</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {responseData.cgiData.map((item, index) => (
                                      <tr key={index}>
                                             <td>{item.seal1_no || "N/A"}</td>
                                             <td>{item.seal2_no || "N/A"}</td>
                                        
                                        <td><StatusBadge status={item.damage_flag || "N"} /></td>
                                   <td>
                                          <div className="d-flex flex-column">
                                            <span>{formatDateTime(item.end_time).date}</span>
                                            <small className="text-muted">{formatDateTime(item.end_time).time}</small>
                                          </div>
                                        </td>
                                            <td>
      <button
        className="btn btn-sm btn-primary"
        onClick={() =>
          handleOpenModal([
            { title: "Seal No 1", url: `https://ctas.live/backend/Seal/`+item.SEAL_1_IMAGE },
            { title: "Seal No 2", url: `https://ctas.live/backend/Seal/`+item.SEAL_2_IMAGE }
          ])
        }
      >
        Evidence
      </button>
    </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No CGI data available</div>}
                          </div>
                        </div>
                      </div>

                      {/* Yard Transactions */}
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="yardHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#yardCollapse" 
                            aria-expanded="false" 
                            aria-controls="yardCollapse"
                          >
                            Yard Transactions
                          </button>
                        </h2>
                        <div 
                          id="yardCollapse" 
                          className="accordion-collapse collapse" 
                          aria-labelledby="yardHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                       <div className="accordion-body p-0">
  {responseData.yard_data?.length > 0 ? (
    <div className="table-responsive">
      <table className="table table-hover align-middle">
        <thead className="table-light">
          <tr>
            <th>Stack To</th>
            <th>Timestamp</th>
            <th>Equipment</th>
            <th>Damage</th>
            {/* <th></th> */}
          </tr>
        </thead>
       <tbody>
  {yardRecordsToShow.map((item, index) => (
    <tr key={index}>
      <td>{item.to || "N/A"}</td>
      <td>
        <div className="d-flex flex-column">
          <span>{formatDateTime(item.yard_created_at).date}</span>
          <small className="text-muted">{formatDateTime(item.yard_created_at).time}</small>
        </div>
      </td>
      <td>{item.equipment_name || "N/A"}</td>
      <td><StatusBadge status={item.damage_flag || "N"} /></td>
      {/* <td>
        <button
          className="btn btn-sm btn-primary"
          onClick={() => handleOpenModal(item.evidenceImage || require('./soon.avif'))}
        >
          Evidence
        </button>
      </td> */}
    </tr>
  ))}
</tbody>
      </table>
    </div>
  ) : (
    <div className="p-3 text-center text-muted">No yard transactions available</div>
  )}
</div>

                        </div>
                      </div>

                      {/* De-Stuffing Transactions */}
                      <div className="accordion-item border-0 mb-3">
                        <h2 className="accordion-header" id="destuffHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#destuffCollapse" 
                            aria-expanded="false" 
                            aria-controls="destuffCollapse"
                          >
                            De-Stuffing Transactions
                          </button>
                        </h2>
                        <div 
                          id="destuffCollapse" 
                          className="accordion-collapse collapse" 
                          aria-labelledby="destuffHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                          <div className="accordion-body" style={{paddingTop:"15px"}}>
                            {responseData.deStuffingData ? (
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <h6 className="text-muted">Container No</h6>
                                    <p className="fw-bold">{responseData.deStuffingData.container_no || "N/A"}</p>
                                  </div>
                                  <div className="mb-3">
                                    <h6 className="text-muted">Container Size</h6>
                                    <p className="fw-bold">{responseData.deStuffingData.size || "N/A"}</p>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <h6 className="text-muted">Shipping Line</h6>
                                    <p className="fw-bold">{responseData.deStuffingData.shipping_liner_code || "N/A"}</p>
                                  </div>
                                  <div className="mb-3">
                                    <h6 className="text-muted">Plan Date</h6>
                                    <p className="fw-bold">
                                      {formatDateTime(responseData.deStuffingData.destuffing_plan_date).date}
                                    </p>
                                  </div>
                                </div>
                                
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <h6 className="text-muted">Start Time</h6>
                                    <p className="fw-bold">
                                      {formatDateTime(responseData.deStuffingData.start_time).date} {formatDateTime(responseData.deStuffingData.start_time).time}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <h6 className="text-muted">End Time</h6>
                                    <p className="fw-bold">
                                      {formatDateTime(responseData.deStuffingData.end_time).date} {formatDateTime(responseData.deStuffingData.end_time).time}
                                    </p>
                                  </div>
                                </div>
                                
                                <div className="col-12 mt-3">
                                  <h6 className="text-primary">Bill Details</h6>
                                  {responseData.deStuffingData.bill_details?.length > 0 ? (
                                    <div className="table-responsive">
                                      <table className="table table-hover align-middle">
                                        <thead className="table-light">
                                          <tr>
                                            {/* <th>BOL Number</th> */}
                                            <th>BOE Number</th>
                                            <th>Area (m²)</th>
                                            <th>Grid Location</th>
                                            <th>No of Packages</th>
                                            <th>Weight</th>
                                            {/* <th></th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {responseData.deStuffingData.bill_details.map((item, index) => (
                                            <tr key={index}>
                                              {/* <td>{item.BOL_NUMBER || "N/A"}</td> */}
                                              <td>{item.BOE_NUMBER || "N/A"}</td>
                                              <td>{item.AREA || "N/A"}</td>
                                              <td>{item.GRID_LOCATIONS || "N/A"}</td>
                                              <td>{item.NO_OF_PACKAGE || "N/A"}</td>
                                              <td>{item.PACKAGE_WEIGHT || "N/A"}</td>
                                                  {/* <td><button
                  className="btn btn-sm btn-primary"
                   onClick={() => handleOpenModal(require('./soon.avif'))}
                >
                  Evidence
                </button></td> */}
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  ) : <div className="p-3 text-center text-muted">No bill details available</div>}
                                </div>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No de-stuffing data available</div>}
                          </div>
                        </div>
                      </div>

                      {/* Delivery Transactions */}
               <div className="accordion-item border-0 mb-3">
  <h2 className="accordion-header" id="deliveryHeading">
    <button
      className="accordion-button bg-light text-primary fw-bold"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#deliveryCollapse"
      aria-expanded="false"
      aria-controls="deliveryCollapse"
    >
      Delivery Transactions
    </button>
  </h2>

  <div
    id="deliveryCollapse"
    className="accordion-collapse collapse"
    aria-labelledby="deliveryHeading"
    data-bs-parent="#transactionAccordion"
  >
    <div className="accordion-body p-0">

      {responseData.delivery_data?.length > 0 ? (
        <div className="table-responsive">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th>Container No</th>
                <th>ICD Loc Code</th>
                <th>CHA Code</th>
                <th>CHA Name</th>
                <th>Container Life</th>
                <th>Truck Arrival</th>
                <th>Start Time</th>
                <th>End Time</th>
                {/* <th></th> */}
              </tr>
            </thead>
            <tbody>
              {responseData.delivery_data.map((item, idx) => (
                <React.Fragment key={idx}>
                  {/* ─────────────── DELIVERY ROW ─────────────── */}
                  <tr>
                    <td>{item.container_no || "N/A"}</td>
                    <td>{item.icd_location_code || "N/A"}</td>
                    <td>{item.cha_code || "N/A"}</td>
                    <td>{item.cha_name || "N/A"}</td>
                    <td>{formatDateTime(item.conatiner_life).date}</td>
                    <td>{formatDateTime(item.truck_arrival_date).date}</td>
                    <td>{formatDateTime(item.start_time).time}</td>
                    <td>{formatDateTime(item.end_time).time}</td>
                    {/* <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleOpenModal(require('./soon.avif'))}
                      >
                        Evidence
                      </button>
                    </td> */}
                  </tr>

                  {/* ─────────────── NESTED TRUCK DETAILS ─────────────── */}
                     <h6 className="ps-3 text-primary">Truck & Grid Details</h6>
                  <tr>
                    <td colSpan={9} className="p-0">
                      {item.truck_details?.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table table-bordered mb-3">
                            <thead className="table-light">
                              <tr>
                                <th>Truck Number</th>
                                <th>Area</th>
                                <th>Grid Locations</th>
                                <th>No. of Packages</th>
                                <th>Package Weight</th>
                              </tr>
                            </thead>
                            <tbody>
                              {item.truck_details.map((truck, j) => (
                                <tr key={j}>
                                  <td>{truck.TRUCK_NUMBER || "N/A"}</td>
                                  <td>{truck.AREA || "N/A"}</td>
                                  <td>{truck.GRID_LOCATIONS || "N/A"}</td>
                                  <td>{truck.NO_OF_PACKAGE || "N/A"}</td>
                                 <td>{truck.PACKAGE_WEIGHT ? Number(truck.PACKAGE_WEIGHT).toFixed(2) : "N/A"}</td>

                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className="p-3 text-center text-muted">
                          No truck details available
                        </div>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="p-3 text-center text-muted">
          No delivery data available
        </div>
      )}

    </div>
  </div>
</div>



                      {/* Gate Out Transactions */}
                      <div className="accordion-item border-0">
                        <h2 className="accordion-header" id="gateOutHeading">
                          <button 
                            className="accordion-button bg-light text-primary fw-bold" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#gateOutCollapse" 
                            aria-expanded="false" 
                            aria-controls="gateOutCollapse"
                          >
                            Gate Out Transactions
                          </button>
                        </h2>
                        <div 
                          id="gateOutCollapse" 
                          className="accordion-collapse collapse" 
                          aria-labelledby="gateOutHeading" 
                          data-bs-parent="#transactionAccordion"
                        >
                          <div className="accordion-body p-0">
                            {responseData.gate_data?.length > 0 ? (
                              <div className="table-responsive">
                                <table className="table table-hover align-middle">
                                  <thead className="table-light">
                                    <tr>
                                      <th>Container No</th>
                                      <th>Vehicle No</th>
                                      <th>Gate Out Time</th>
                                      <th>Permit No</th>
                                      <th>Damage</th>
                                      <th>Hazardous</th>
                                      <th>Gate No</th>
                                      <th>SLINE Code</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {responseData.gate_data.map((item, index) => (
                                      <tr key={index}>
                                        <td>{item.container_no || "N/A"}</td>
                                        <td>{item.vehicle_no || "N/A"}</td>
                                        <td>
                                          <div className="d-flex flex-column">
                                            <span>{formatDateTime(item.gate_out_time).date}</span>
                                            <small className="text-muted">{formatDateTime(item.gate_out_time).time}</small>
                                          </div>
                                        </td>
                                        <td>{item.permit_no || "N/A"}</td>
                                        <td><StatusBadge status={item.is_container_damage || "N"} /></td>
                                        <td><StatusBadge status={item.hazardous_container || "N"} /></td>
                                         <td>{item.gate_no || "N/A"}</td>
                                          <td>{item.sline_code || "N/A"}</td>
           <td>
  <button
    className="btn btn-sm btn-primary"
    onClick={() => {
      const images = [
        { title: "Vehicle No Image", url: `https://ctas.live/ocr_backend/uploads/${item.vehicle_no_img}` }
      ];

      // check permit_no prefix (case-insensitive)
      if (item.permit_no && /^(pma|pmd|gpcp)/i.test(item.permit_no)) {
        images.push({
          title: "Container Image",
          url: `https://ctas.live/ocr_backend/uploads/${item.container_image}`
        });
      }

      handleOpenModal(images);
    }}
  >
    Evidence
  </button>
</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            ) : <div className="p-3 text-center text-muted">No gate out data available</div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="dashboard-footer py-3 bg-light border-top">
        <div className="container">
          {/* <p className="mb-0 text-center text-muted">
            Powered by <span className="text-primary">SUNIC TECHNOLOGIES</span> 
            </p> */}
        </div>
      </footer>
        <Modal show={showModal} onHide={handleCloseModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>Evidence Images</Modal.Title>
  </Modal.Header>
  <Modal.Body className="text-center">
    {popupImages && popupImages.length > 0 ? (
      popupImages.map((img, index) => (
        <div key={index} className="mb-4">
          <h6 className="mb-2">{img.title || `Image ${index + 1}`}</h6>
          <img
            src={img.url}
            alt={img.title || `Evidence ${index + 1}`}
            style={{ maxWidth: "100%", maxHeight: "400px" }}
            className="rounded shadow-sm"
          />
        </div>
      ))
    ) : (
      <p>No images available</p>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseModal}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

        <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">{detailData?.title} Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
  {detailData ? (
    <table className="table table-striped">
      <tbody>
        {Object.entries(detailData.record)
          // remove plain objects (keep arrays)
          .filter(([_, v]) => !(v && typeof v === "object" && !Array.isArray(v)))
          .map(([key, val]) => {
            const isDateString =
              typeof val === "string" && !isNaN(Date.parse(val));

            // prepare display which can be a string or a React node
            let display = "";

            if (val == null) {
              display = "";
            } else if (isDateString) {
              display = `${formatDateTime(val).date} ${formatDateTime(val).time}`;
            } else if (Array.isArray(val)) {
              if (val.length === 0) {
                display = "";
              } else {
                const allObjects = val.every(
                  (el) => el && typeof el === "object" && !Array.isArray(el)
                );

                if (allObjects) {
                  // Array of objects → show collapsible pretty JSON
                  display = (
                    <details>
                      <summary>{`${val.length} item${val.length > 1 ? "s" : ""} (click to expand)`}</summary>
                      <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                        {JSON.stringify(val, null, 2)}
                      </pre>
                    </details>
                  );
                } else {
                  // Array of primitives or mixed → join nicely
                  display = val
                    .map((el) => (el && typeof el === "object" ? JSON.stringify(el) : String(el)))
                    .join(", ");
                }
              }
            } else {
              // primitive (number/string/boolean)
              display = String(val);
            }

            return (
              <tr key={key}>
                <th style={{ textTransform: "capitalize" }}>
                  {key.replace(/_/g, " ")}
                </th>
                <td>{display}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  ) : (
    <p>No data available.</p>
  )}
</Modal.Body>


        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
    </div>
  );
};

export default Import;